// Translation: Interface > Copy button (Turkish)
export default Object.freeze({
	idle: 'Kopyala',
	success: 'Kopyalandı'
})
